export class M3PDetalleItems {
    public NombreConcepto: string;
    public Valor: string;
}

export class M3PItemsWEB {
    public dCantidad: number;
    public dPrecioTotal: number;
    public BisProductoPromo: boolean = false;
    public BisObsequio: boolean = false;

    public Unidad: string = "";
    public ClavePrdSRV: string = "";
    public ClavePrdUnidad: string = "";
    public IdProceso: string = "";
    public observacion: string = "";

    public SubEstado_o: string = "";
    public Estado_o: string = "";
    public PathImagen: string = "";

    public IDEncRepetido: number = -1;
    public IDEncProcesado: number = -1;
    public IDEncPadre: number = -1;
    public TipoAgrupacion: string = "";
    public CodigoBarras: string = "";
    public CamposAdicionales = [];
}

export class M3PDetalleCupon {
    public IdCupon: string;
    public Cantidad: number;
}
